// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionHeader_institution-header__VNHzH {
  position: absolute;
  top: calc(var(--navbar-height) + 12px);
  color: white !important;
  left: 30px;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb__qrruT {
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb__qrruT svg {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb__qrruT svg path {
  stroke-width: 1.5px;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb-current__iLjK9 {
  cursor: pointer;
  font-weight: bold;
  color: white;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .ant-breadcrumb-separator {
  color: white;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb__qrruT {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb__qrruT svg {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb__qrruT svg path {
  stroke-width: 1px;
  stroke: grey;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb-current__iLjK9 {
  cursor: pointer;
  color: var(--explore-color);
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof {
  display: flex;
  align-items: center;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_tab-no-landscape__LsA1I {
  padding: 10px;
  font-size: 13px;
  background: rgb(235, 235, 235);
  color: black;
  border-radius: 10px 10px 0 0;
  margin-right: 2px;
  cursor: pointer;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_selected-no-landscape__YbF77 {
  background: var(--explore-color);
  color: white;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_tab__JzOwa {
  padding: 10px;
  font-size: 13px;
  background: rgb(235, 235, 235);
  color: black;
  border-radius: 10px 10px 0 0;
  margin-right: 2px;
  cursor: pointer;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_tab__JzOwa:hover {
  background: white;
}
.InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_selected__f2udj {
  color: var(--explore-color);
  background: white;
}
@media only screen and (min-width: 481px) and (max-width: 1024px) {
  .InstitutionHeader_institution-header__VNHzH {
    position: absolute;
    top: calc(13.8095238095vh + 1px);
  }
}
@media only screen and (max-width: 480px) {
  .InstitutionHeader_institution-header__VNHzH {
    position: relative;
    width: 95%;
    top: 0;
    margin-top: 20px;
    left: 0;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb__qrruT,
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb__qrruT {
    color: grey;
    display: flex;
    align-items: center;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb__qrruT svg,
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb__qrruT svg {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb__qrruT svg path,
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb__qrruT svg path {
    stroke: grey;
    stroke-width: 1.5px;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .InstitutionHeader_bread-crumb-current__iLjK9,
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .InstitutionHeader_bread-crumb-current__iLjK9 {
    font-weight: bold;
    color: var(--explore-color);
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb__pF-hX .ant-breadcrumb-separator,
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_breadcrumb-no-landscape__4QRuC .ant-breadcrumb-separator {
    color: grey;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof {
    display: flex;
    align-items: center;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_tab__JzOwa,
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_tab-no-landscape__LsA1I {
    padding: 10px;
    font-size: 13px;
    background: rgb(235, 235, 235);
    color: black;
    border-radius: 10px 10px 0 0;
    margin-right: 2px;
    cursor: pointer;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_selected__f2udj,
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_selected-no-landscape__YbF77 {
    background: var(--explore-color);
    color: white;
  }
  .InstitutionHeader_institution-header__VNHzH .InstitutionHeader_tabs__WsOof .InstitutionHeader_tab__JzOwa:hover {
    background: var(--explore-color);
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/InstitutionHeader/InstitutionHeader.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sCAAA;EACA,uBAAA;EACA,UAAA;AACF;AACI;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAER;AADQ;EACE,mBAAA;AAGV;AACI;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AACN;AACI;EACE,YAAA;AACN;AAGI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AADN;AAEM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAAR;AACQ;EACE,iBAAA;EACA,YAAA;AACV;AAGI;EACE,eAAA;EACA,2BAAA;AADN;AAIE;EACE,aAAA;EACA,mBAAA;AAFJ;AAGI;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,YAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;AADN;AAGI;EACE,gCAAA;EACA,YAAA;AADN;AAGI;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,YAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;AADN;AAGI;EACE,iBAAA;AADN;AAGI;EACE,2BAAA;EACA,iBAAA;AADN;AAIE;EAlFF;IAmFI,kBAAA;IACA,gCAAA;EADF;AACF;AAEE;EAtFF;IAuFI,kBAAA;IACA,UAAA;IACA,MAAA;IACA,gBAAA;IACA,OAAA;EACF;EAEI;;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EACN;EAAM;;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAGR;EAFQ;;IACE,YAAA;IACA,mBAAA;EAKV;EADI;;IACE,iBAAA;IACA,2BAAA;EAIN;EAFI;;IACE,WAAA;EAKN;EAFE;IACE,aAAA;IACA,mBAAA;EAIJ;EAHI;;IAEE,aAAA;IACA,eAAA;IACA,8BAAA;IACA,YAAA;IACA,4BAAA;IACA,iBAAA;IACA,eAAA;EAKN;EAHI;;IAEE,gCAAA;IACA,YAAA;EAKN;EAHI;IACE,gCAAA;EAKN;AACF","sourcesContent":[".institution-header {\n  position: absolute;\n  top: calc(var(--navbar-height) + 12px);\n  color: white !important;\n  left: 30px;\n  .breadcrumb {\n    .bread-crumb {\n      cursor: pointer;\n      color: white;\n      display: flex;\n      align-items: center;\n      svg {\n        width: 20px;\n        height: 20px;\n        margin-right: 6px;\n        path {\n          stroke-width: 1.5px;\n        }\n      }\n    }\n    .bread-crumb-current {\n      cursor: pointer;\n      font-weight: bold;\n      color: white;\n    }\n    :global(.ant-breadcrumb-separator) {\n      color: white;\n    }\n  }\n  .breadcrumb-no-landscape {\n    .bread-crumb {\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      svg {\n        width: 20px;\n        height: 20px;\n        margin-right: 6px;\n        path {\n          stroke-width: 1px;\n          stroke: grey;\n        }\n      }\n    }\n    .bread-crumb-current {\n      cursor: pointer;\n      color: var(--explore-color);\n    }\n  }\n  .tabs {\n    display: flex;\n    align-items: center;\n    .tab-no-landscape {\n      padding: 10px;\n      font-size: 13px;\n      background: rgb(235, 235, 235);\n      color: black;\n      border-radius: 10px 10px 0 0;\n      margin-right: 2px;\n      cursor: pointer;\n    }\n    .selected-no-landscape {\n      background: var(--explore-color);\n      color: white;\n    }\n    .tab {\n      padding: 10px;\n      font-size: 13px;\n      background: rgb(235, 235, 235);\n      color: black;\n      border-radius: 10px 10px 0 0;\n      margin-right: 2px;\n      cursor: pointer;\n    }\n    .tab:hover {\n      background: white;\n    }\n    .selected {\n      color: var(--explore-color);\n      background: white;\n    }\n  }\n  @media only screen and (min-width: 481px) and (max-width: 1024px) {\n    position: absolute;\n    top: calc(290vh / 21 + 1px);\n  }\n  @media only screen and (max-width: 480px) {\n    position: relative;\n    width: 95%;\n    top: 0;\n    margin-top: 20px;\n    left: 0;\n    .breadcrumb,\n    .breadcrumb-no-landscape {\n      .bread-crumb {\n        color: grey;\n        display: flex;\n        align-items: center;\n        svg {\n          width: 20px;\n          height: 20px;\n          margin-right: 6px;\n          path {\n            stroke: grey;\n            stroke-width: 1.5px;\n          }\n        }\n      }\n      .bread-crumb-current {\n        font-weight: bold;\n        color: var(--explore-color);\n      }\n      :global(.ant-breadcrumb-separator) {\n        color: grey;\n      }\n    }\n    .tabs {\n      display: flex;\n      align-items: center;\n      .tab,\n      .tab-no-landscape {\n        padding: 10px;\n        font-size: 13px;\n        background: rgb(235, 235, 235);\n        color: black;\n        border-radius: 10px 10px 0 0;\n        margin-right: 2px;\n        cursor: pointer;\n      }\n      .selected,\n      .selected-no-landscape {\n        background: var(--explore-color);\n        color: white;\n      }\n      .tab:hover {\n        background: var(--explore-color);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"institution-header": `InstitutionHeader_institution-header__VNHzH`,
	"breadcrumb": `InstitutionHeader_breadcrumb__pF-hX`,
	"bread-crumb": `InstitutionHeader_bread-crumb__qrruT`,
	"bread-crumb-current": `InstitutionHeader_bread-crumb-current__iLjK9`,
	"breadcrumb-no-landscape": `InstitutionHeader_breadcrumb-no-landscape__4QRuC`,
	"tabs": `InstitutionHeader_tabs__WsOof`,
	"tab-no-landscape": `InstitutionHeader_tab-no-landscape__LsA1I`,
	"selected-no-landscape": `InstitutionHeader_selected-no-landscape__YbF77`,
	"tab": `InstitutionHeader_tab__JzOwa`,
	"selected": `InstitutionHeader_selected__f2udj`
};
export default ___CSS_LOADER_EXPORT___;
